import { KlaraDocument } from '../../model/klara';

/**
 * The protocol that judges what was delivered.
 *
 * `evaluation_protocol` arrives once per QA iteration, and `has_many
 * :documents` declares no order — so row order is whatever Postgres returns
 * and cannot be read as "newest last". Both screens ask this question, and
 * they have to give the same answer: the button label is the same on each.
 */
export function newestProtocol(documents: KlaraDocument[] | undefined) {
  return protocolsNewestFirst(documents)[0];
}

/** Newest first, so callers can take the head and list the rest as history. */
export function protocolsNewestFirst(documents: KlaraDocument[] | undefined) {
  return (documents ?? [])
    .filter((document) => document.document_type === 'evaluation_protocol')
    .slice()
    .sort(
      (a, b) =>
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
    );
}
